import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  plbBadge: 'New',
  plbTitle: 'Create payment link',
  plbTourMessage:
    'Request your transfers by creating payment links for your customers.',
  plbTourOmit: 'Skip',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const PAYMENT_LINK_BUTTON_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    plbBadge: 'Nuevo',
    plbTitle: 'Crear link de cobro',
    plbTourMessage:
      'Solicita tus transferencias creando links de cobro para tus clientes.',
    plbTourOmit: 'Omitir',
  },
};

export default PAYMENT_LINK_BUTTON_LABELS;
